import React, { useState } from "react";
import { Stack, TextField } from "@mui/material";
import GroupedSelect from "../../utils/GroupedSelect";
import { ReadOnlyCell } from "../../utils/CommonTable";
import { countries, DEFAULT_COUNTRY, getCountry } from "./calculations";

const CountryField = ({
  country,
  onChange,
  disabled = false,
  canEdit = true,
  unspecifiedValue = "",
}) => {
  const countryOptions = [
    { value: unspecifiedValue, label: DEFAULT_COUNTRY, group: "Countries" },
    ...countries,
  ];
  const value = country === DEFAULT_COUNTRY ? unspecifiedValue : country || "";
  const isCustomCountry = Boolean(value) && (
    value === "Other" || !countryOptions.some((option) => option.value === value)
  );
  // Keep the input open while typing, even if the name matches a listed country.
  const [otherSelected, setOtherSelected] = useState(false);
  const showCustomInput = otherSelected || isCustomCountry;

  if (!canEdit) {
    return <ReadOnlyCell value={getCountry(country)} width='100%' />;
  }

  return (
    <Stack spacing={1} sx={{ minWidth: 180 }}>
      <GroupedSelect
        value={showCustomInput ? "Other" : value}
        onChange={(e) => {
          setOtherSelected(e.target.value === "Other");
          onChange(e.target.value);
        }}
        options={countryOptions}
        placeholder={DEFAULT_COUNTRY}
        enableSearch
        disabled={disabled}
      />
      {showCustomInput && (
        <TextField
          label='Country name'
          placeholder='Enter country name'
          value={value === "Other" ? "" : value}
          onChange={(e) => {
            setOtherSelected(true);
            onChange(e.target.value || "Other");
          }}
          onBlur={(e) => {
            const trimmedValue = e.target.value.trim() || "Other";
            if (trimmedValue !== value) onChange(trimmedValue);
          }}
          disabled={disabled}
          size='small'
          fullWidth
          autoComplete='off'
          sx={{ bgcolor: "background.paper" }}
        />
      )}
    </Stack>
  );
};

export default CountryField;
